import React from 'react';

import {useAppContext} from '../hooks';
import {stopImpersonation} from '../api/api';

const ImpersonationBanner = () => {
  const {currentUser, impersonatingFrom} = useAppContext();

  if (!impersonatingFrom) return null;

  const handleStopImpersonation = async () => {
    await stopImpersonation();
    window.location.href = `/admin/users/${currentUser.email}`;
  };

  return (
    <div className="bg-yellow-500 text-black py-3 px-4 text-center fixed bottom-0 left-0 right-0 z-50">
      <span className="font-medium">
        You are impersonating
        {' '}
        <span className="font-semibold">{currentUser.email}</span>
      </span>
      <button
        type="button"
        onClick={handleStopImpersonation}
        className="ml-6 bg-black text-white px-3 py-1 rounded text-sm font-medium hover:bg-gray-800"
      >
        Exit impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
